module.exports = flarum.core.compat['mentions/fragments/PostQuoteButton'];